module.exports = __webpack_public_path__ + "img/20.7c9282a8.gif";